import Button from '@app/ui/components/Button';
import PasswordInput from '@app/ui/components/PasswordInput';
import TextInput from '@app/ui/components/TextInput';
import styled from 'styled-components';

export const StyledInput = styled(TextInput)`
  width: 100%;
  &:not(:last-child) {
    margin-bottom: 32px;
  }
`;

export const StyledButton = styled(Button)`
  width: 100%;
  margin-top: 20px;
`;

export const StyledPasswordInput = styled(PasswordInput)`
  margin-bottom: 32px;
`;
